// hooks/useOwnerUsers.ts — async loader for the owner users list.
import { useCallback, useEffect, useState } from 'react';
import { ownerService } from '@/core/services/ownerService';
import type { OwnerUserRow } from '@/core/models';

export function useOwnerUsers(q = '', verified = '', status = '') {
  const [data, setData] = useState<OwnerUserRow[] | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);
  const refetch = useCallback(() => setTick((t) => t + 1), []);
  useEffect(() => {
    let alive = true;
    // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional loader flag
    setLoading(true);
    ownerService
      .getUsers(q, verified, status)
      .then((r) => { if (alive) { setData(r.results); setError(null); } })
      .catch(() => { if (alive) setError('Failed to load users'); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [q, verified, status, tick]);
  return { data, loading, error, refetch };
}
